import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import 'intersection-observer'

import AppStateMixin from './mixins/appstate'
import LoadingState from './components/LoadingState.vue'
import MainMenu from './components/MainMenu.vue'
import Breadcrumb from './components/Breadcrumb.vue'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false
Vue.mixin(AppStateMixin)

Vue.component('LoadingState', LoadingState)
Vue.component('MainMenu', MainMenu)
Vue.component('Breadcrumb', Breadcrumb)

Vue.prototype.$globalEvents = new Vue()

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
